// theme.js
import { createTheme } from "@mui/material/styles";
import themeJson from "./theme.json";

const theme = createTheme(themeJson);

export default theme;
